import { MessageCircle } from "lucide-react";
import { PROFILE } from "../data/content";

export const WhatsAppFloat = () => {
  const href = `https://wa.me/${PROFILE.whatsapp_raw}?text=${encodeURIComponent(
    "Olá, Dra. Nivalda. Gostaria de agendar uma consulta."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1fb457] text-white px-4 py-3 rounded-full shadow-lg shadow-black/20 transition-colors">
        <MessageCircle size={22} />
        <span className="hidden md:inline font-medium text-sm pr-1">WhatsApp</span>
      </span>
    </a>
  );
};
